<footer>
    <div class="container">
      <div class="flex-container justify row">
        <div>
          <p>PDFSkills © 2022</p>
        </div>
        <div>
          <ul>
            <li><a target="_blank" href="https://www.pdfskillsapp.com/eula">EULA</a></li>
            <li><a target="_blank" href="https://www.pdfskillsapp.com/privacy">Privacy</a></li>
            <li><a target="_blank" href="https://www.pdfskillsapp.com/uninstall">Uninstall</a></li>
            <li><a target="_blank" href="https://www.pdfskillsapp.com/contact">Contact</a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>